<template>
  <div>
    <banner></banner>
    <empresa></empresa>
    <produtos></produtos>
    <social></social>
    <contato></contato>
  </div>
</template>

<script>
import Banner from '../Banner'
import Empresa from '../Empresa'
import Social from '../Social'
import Contato from '../Contato'
import Produtos from '../Produtos'

export default {
  components: {
    banner: Banner,
    empresa: Empresa,
    social: Social,
    contato: Contato,
    produtos: Produtos
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/Home.vue